import { Component } from '@angular/core';
import { concat } from 'rxjs';
import { ConfigService } from 'src/app/services/config.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent {
  version: string = '';

  constructor(private configService: ConfigService) {}

  ngOnInit(): void {
    this.version = String(this.configService.settings.versionRelease.portal);
  }
}
